// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F9qwn","tabsBox":"styles_tabsBox__PVTFP","createButton":"styles_createButton__FuKTI"};